/**
 * Erros das telas no Sentry, sem PII (AGENTS.md, regra 1). O filtro é o mesmo da API
 * (`@odus/obs-sdk/sentry`). Sem breadcrumbs (cliques e console podem levar texto da tela),
 * sem replay e sem tracing. Sem DSN, fica desligado.
 */
import * as Sentry from "@sentry/react";
import { SENTRY_NO_DATA_COLLECTION, scrubSentryEvent } from "@odus/obs-sdk/sentry";

import { env } from "./env";

export function startSentry(): void {
  if (!env.sentryDsn) return;
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.environment,
    release: env.release,
    dataCollection: SENTRY_NO_DATA_COLLECTION,
    tracesSampleRate: 0,
    integrations: (defaults) => defaults.filter((i) => i.name !== "Breadcrumbs"),
    beforeBreadcrumb: () => null,
    beforeSend: (event) => scrubSentryEvent(event),
  });
}
